var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageLiquityV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 96C0 42.9807 42.9807 0 96 0C149.019 0 192 42.9807 192 96C192 149.019 149.019 192 96 192C42.9807 192 0 149.019 0 96Z",
    fill: "url(#paint0_linear_231_7777)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0011 147.437C124.409 147.437 147.437 124.408 147.437 95.9998C147.437 67.5915 124.409 44.5623 96.0011 44.5623C67.5934 44.5623 44.5645 67.5915 44.5645 95.9998C44.5645 124.408 67.5934 147.437 96.0011 147.437ZM96.0011 151C126.377 151 151.001 126.376 151.001 95.9998C151.001 65.6236 126.377 40.999 96.0011 40.999C65.6255 40.999 41.0012 65.6236 41.0012 95.9998C41.0012 126.376 65.6255 151 96.0011 151Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96 151C126.376 151 151 126.376 151 95.9995C151 89.5973 149.906 83.4504 147.895 77.7357C146.9 77.692 145.898 77.6699 144.893 77.6699C107.085 77.6699 76.0786 110.179 77.7355 147.895C83.4503 149.906 89.5974 151 96 151Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.667 44.1279V144.778L78.4391 147.982V148.114L77.667 147.87C56.305 140.32 41 119.947 41 95.9992C41 72.0514 56.305 51.6782 77.667 44.1279Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_231_7777",
    x1: 96,
    y1: 0,
    x2: 96,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EB6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#745DDF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageLiquityV2);
export default __webpack_public_path__ + "static/media/page-liquity-v2.3f9e5b468aafb30ae7b3bbc030f988ed.svg";
export { ForwardRef as ReactComponent };